// extracted by mini-css-extract-plugin
module.exports = {"h1":"base_h1__2QDnB","h2":"base_h2__3q7L0","h3":"base_h3__2JZAR","h4":"base_h4__2fg8S"};